
import HomePage from 'pages/HomePage';
import LoginPage from 'pages/LoginPage';
import SearchPage from 'pages/SearchPage';
import CalendarPage from 'pages/CalendarPage';
import UploadPage from 'pages/UploadPage';
import QuickviewPage from 'pages/UploadPage/QuickviewPage';
import PeoplePage from 'pages/PeoplePage';
import IntegrationsPage from 'pages/IntegrationsPage';
import GroupPage from 'pages/GroupPage';
import NoMatchPage from 'pages/NoMatchPage';

import { Navigate, Route, Routes, BrowserRouter as Router, Outlet, useLocation , createBrowserRouter, RouterProvider} from "react-router-dom";
import { useSelector } from "react-redux";
import NavDrawer from 'components/NavDrawer';
import { Box, Toolbar } from '@mui/material';
import { getNextNavState } from 'utils/loader';
import { NavContext } from 'context/NavContext';
import { useContext } from 'react';

const Routing = () => {
    const isAuth = Boolean(useSelector((state) => state.auth.token));

    const NavWrapper = ({ element }) => (
        <Box display="flex">
            <NavDrawer />
            <Box width="100%">
                {<Toolbar/>}
                {element}
            </Box>
        </Box>
    );

    const router = createBrowserRouter([
        {
            path: '/',
            element: <NavWrapper element={<HomePage />} />,
        },
        {
            path: '/login',
            element: isAuth ? <Navigate to="/" />
                            : <NavWrapper element={<LoginPage />} />,
        },
        {
            path: '/search',
            element: isAuth ? <NavWrapper element={<SearchPage />} />
                            : <Navigate to="/login" />,
        },
        {
            path: '/calendar',
            element: isAuth ? <NavWrapper element={<CalendarPage />} />
                            : <Navigate to="/login" />,
        },
        {
            path: '/upload',
            element: isAuth ? <NavWrapper element={<UploadPage />} />
                            : <Navigate to="/login" />,
        },
        {
            path: '/integrations',
            element: isAuth ? <NavWrapper element={<IntegrationsPage />} />
                            : <Navigate to="/login" />,
        },
        {
            path: '/people',
            element: isAuth ? <NavWrapper element={<Outlet />} />
                            : <Navigate to="/login" />,
            children: [
                { index: true, element: <></> },
                { path: ':resourceType/:resourceId', element: <PeoplePage /> },
            ],
        },
        {
            path: '*',
            element: <NavWrapper element={<NoMatchPage />} />,
        },
    ]);
    
    //const { pathname } = useLocation();
    return (
       /*<Box display="flex">
            <NavDrawer 
                showHeader//={showHeader} 
                showSidebar//={showSidebar} 
                //showSecondarySidebar={showSecondarySidebar} 
                //isCalendar={isCalendar} 
            />
            <Box width="100%">
                {<Toolbar/>}

                {<Routes>
                    <Route path="/"                 element={ <HomePage />} />
                    <Route path="/login"            element={ <LoginPage /> } />
                    <Route path="/search"           element={ isAuth ? <SearchPage />         
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/calendar"         element={ isAuth ? <CalendarPage />       
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/upload"           element={ isAuth ? <UploadPage />        
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/upload/quickview" element={ isAuth ? <QuickviewPage />      
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/integrations"     element={ isAuth ? <IntegrationsPage />   
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/people"           element={ isAuth ? <PeoplePage />       
                                                                        : <Navigate to="/login" /> } >
                        <Route index pathelement={ <PeoplePage /> } />
                        <Route path=":resourceType/:resourceId" element={ <PeoplePage /> } />
                    </Route>
                    <Route path="/people/:resourceType/:resourceId" element={ isAuth ? <PeoplePage />         
                                                                        : <Navigate to="/login" /> } />
                    <Route path="/groups/:groupId"  element={ isAuth ? <GroupPage />          
                                                                        : <Navigate to="/login" /> } />
                    <Route path="*" element={<NoMatchPage />} />
    </Routes>}
                <RouterProvider router={router}/>
            </Box>
        </Box>*/

        <RouterProvider router={router}/>
    )
};

export default Routing;